import React, { useState } from 'react';

export default ({ defaults = {} } = {}) => {
	const [form, setForm] = useState(defaults);
	return {
		form,
		setItem: (key, value) => {
			if (value) {
				setForm({ ...form, [key]: value });
			} else {
				delete form[key];
				setForm(form);
			}

			return form;
		},
		reset: (data) => setForm(data || defaults),
	};
};
